<template>
    <div class="vote" v-loading='proloading'>
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div></div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">
                            新增中药
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <el-table :data="proData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="id" label="序号" width="80"></el-table-column>
            <el-table-column prop="name" label="中药名称" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                        @click="handleEdit(scope.row,scope.$index)"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                        @click="handleDelet(scope.row,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新建" :visible.sync="adddialogVisible" top="50px" width="50%" class="dialogs" append-to-body
            :close-on-click-modal='false'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="problems" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <div class="problem_box">
                        <el-form-item label="标题" style="margin-top:10px" prop="problem">
                            <el-input v-model="ruleForm.problem" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="内容模块">
                            <el-select v-model="ruleForm.jbxx_value" placeholder="请选择" size="small" filterable
                                clearable>
                                <el-option v-for="item in jbxx_options" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                            <el-button type="primary" @click="addJB" size="small" style="margin-left:10px">添加
                            </el-button>
                        </el-form-item>
                        <div v-for="(item,index) in list" :key="index">
                            <el-form-item :label="item.dimension_name" prop='lb_content'>
                                <tinymce ref="editor" v-model="item.dimension_content" :key="index+1"
                                    toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
                                <el-button type="primary" @click="delJB(index)" size="small" style="margin-left:10px">删除
                                </el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">确 定
                </el-button>
                <el-button @click="adddialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Tinymce from '@/components/common/tinymce.vue';

    export default {
        components: {
            Tinymce,
        },
        data() {
            return {
                proData: [],
                textId: '',
                loading: false,
                subloading: false,
                height: null,
                adddialogVisible: false,
                ruleForm: {
                    problem: "",
                    jbxx_value:'',
                },
                problems: {
                    problem: [{
                        required: true,
                        message: '问题必填',
                        trigger: 'blur'
                    }, ],
                    contents: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],
                },
                eid: '',
                proloading: false,
                editindex: 1,
                jbxx_options: [],
                list: [],
                addloading:false
            }
        },
        mounted() {
            this.getHeight()
            this.getinfoxx()

            // this.getlist()

        },
        methods: {
            getHeight() {
                let that = this
                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {
                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            getinfoxx() {
                let that = this
                axios
                    .post("/admin/knowledgecategory/categorySelect", {}, {
                        token: true
                    })
                    .then(response => {
                        that.jbxx_options = response.data.data
                    })
                    .catch(error => {})
            },
            handleAdd() {
                this.clearf()
                this.eid = ''
                this.adddialogVisible = true
            },
            clearf() {
                let that = this
                this.editindex++
                this.ruleForm.problem = ''
               this.ruleForm.jbxx_value= ''
                that.list = []
            },
            getlist(id) {
                this.proData = []
                this.proloading = true
                axios
                    .post("/admin/pc/drugs/Mlist", {
                        pid: id,
                        page: 1,
                        page_count: 100,

                    }, {
                        token: true
                    })
                    .then(response => {
                        this.proloading = false
                        if (response.data.code == '200') {
                            this.proData = response.data.data.list
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            handleEdit(row, index) {
                this.clearf()
                let that = this
                this.ruleForm.problem = row.name
                this.eid = row.id
                axios
                    .post("/admin/pc/drugs/read", {
                        id: row.id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.ruleForm.problem=response.data.data.name
                            that.list=response.data.data.ChineseDimension
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
                this.adddialogVisible = true
            },
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该问题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.proloading = true
                    axios
                        .post("/admin/pc/drugs/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist(this.textId)
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let urls
                        if (this.eid && this.eid != '') {
                            urls = "/admin/pc/drugs/update"
                        } else {
                            urls = "/admin/pc/drugs/save"
                        }
                        this.subloading = true
                        axios.post(urls, {
                                id: that.eid,
                                pid: this.textId,
                                name: this.ruleForm.problem,
                                sort: '',
                                dimensions:this.list,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.adddialogVisible = false
                                    that.getlist(this.textId)
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        // this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            addJB() {
                let that = this
                if (!this.ruleForm.jbxx_value) return that.$message('请选择内容模块');

                if (this.list.length > 0) {
                    var flag = false
                    this.list.forEach((element) => {
                        if (element.dimension_id == this.ruleForm.jbxx_value) {
                            flag = true
                        }
                    })
                }
                if (flag) return that.$message('不能选择重复的信息');
                var obj = {
                    dimension_id: '',
                    dimension_content: '',
                    dimension_name: ''
                }
                obj.dimension_id = this.ruleForm.jbxx_value
                obj.dimension_name = this.jbxx_options.find(element => {
                    return element.id == this.ruleForm.jbxx_value
                }).name
                obj.dimension_content = ''
                this.list.push(obj)
            },
            delJB(index) {
                this.list.splice(index, 1)
            },
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>